<template>
  <div class="total-cost-container" ref="containerRef">
    <div class="input-area">
      <div class="input-row">
        <div class="input-group">
          <label class="input-label">修理费率</label>
          <input
            type="number"
            v-model.number="inputData.repairRate"
            class="input-field"
            placeholder="请输入修理费率"
            step="0.01"
            min="0"
            max="100"
            @change="updateTotalCost"
          />
          <span class="input-unit">%</span>
        </div>
        <div class="input-group">
          <label class="input-label">年其他费用</label>
          <input
            type="number"
            v-model.number="inputData.otherCost"
            class="input-field"
            placeholder="请输入其他费用"
            step="0.01"
            min="0"
            @change="updateTotalCost"
          />
          <span class="input-unit">万元</span>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="total-cost-table">
          <thead>
            <tr>
              <th class="seq-col">序号</th>
              <th class="item-col">项 目</th>
              <th class="total-col">合计</th>
              <th class="year-col" v-for="year in displayYears" :key="year">
                {{ year }}
              </th>
            </tr>
            <tr>
              <th class="seq-col">-</th>
              <th class="item-col">建设期/运营期</th>
              <th class="total-col">-</th>
              <template v-for="(group, groupIndex) in yearSpanGroups">
                <th class="year-col period-type-col" :colspan="group.length">
                  <span v-if="group.type === 'construction'">建设期</span>
                  <span v-else>运营期</span>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="seq-col">1</td>
              <td class="item-col">原辅材料</td>
              <td class="total-col">
                {{ formatNumber(totalCost.rawmaterial.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`rawmaterial-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.rawmaterial.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">2</td>
              <td class="item-col">燃料动力</td>
              <td class="total-col">
                {{ formatNumber(totalCost.fuelPpower.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`fuelPpower-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.fuelPpower.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">3</td>
              <td class="item-col">工资福利</td>
              <td class="total-col">
                {{ formatNumber(totalCost.wagesBenefits.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`wagesBenefits-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.wagesBenefits.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">4</td>
              <td class="item-col">修理费</td>
              <td class="total-col">
                {{ formatNumber(totalCost.repair.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`repair-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.repair.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">5</td>
              <td class="item-col">其他费用</td>
              <td class="total-col">
                {{ formatNumber(totalCost.other.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`other-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.other.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="highlight-row">
              <td class="seq-col"></td>
              <td class="item-col">经营成本</td>
              <td class="total-col">
                {{ formatNumber(totalCost.Operatingcosts.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`operatingCosts-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.Operatingcosts.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">6</td>
              <td class="item-col">折旧</td>
              <td class="total-col">
                {{ formatNumber(totalCost.depreciation.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`depreciation-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.depreciation.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">7</td>
              <td class="item-col">摊销</td>
              <td class="total-col">
                {{ formatNumber(totalCost.Amortization.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`amortization-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.Amortization.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="seq-col">8</td>
              <td class="item-col">利息</td>
              <td class="total-col">
                {{ formatNumber(totalCost.interest.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`interest-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.interest.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr class="highlight-row">
              <td class="seq-col"></td>
              <td class="item-col">总成本费用合计</td>
              <td class="total-col">
                {{ formatNumber(totalCost.Totalcost.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`total-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.Totalcost.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="bold-row">
              <td class="seq-col"></td>
              <td class="item-col">固定成本</td>
              <td class="total-col">
                {{ formatNumber(totalCost.fixedcost.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`fixedCost-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.fixedcost.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="bold-row">
              <td class="seq-col"></td>
              <td class="item-col">可变成本</td>
              <td class="total-col">
                {{ formatNumber(totalCost.variablecost.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in displayYears"
                :key="`variableCost-${yearIndex}`"
              >
                <span>{{
                  formatNumber(totalCost.variablecost.year[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { totalCost, workingCapital } from "@/utils/comp.js";

export default {
  name: "TotalCost",
  data() {
    const costData = this.$store.state.projectData?.["成本费用"] || {};
    return {
      inputData: {
        repairRate: costData.repaircost || 0, // 从store读取年修理费率，默认0
        otherCost: costData.othercost || 0, // 从store读取年其他费用，默认0
      },
    };
  },
  computed: {
    projectData() {
      return this.$store.state.projectData || {};
    },
    basicData() {
      return this.projectData["基础数据"] || {};
    },
    // 不再使用成本费用对象，只使用总成本费用对象
    costData() {
      return {};
    },
    calculationPeriod() {
      return this.basicData?.calculationPeriod || 12;
    },
    constructionPeriod() {
      return this.basicData?.constructionPeriod || 1;
    },
    operationPeriod() {
      return this.basicData?.operationPeriod || 11;
    },
    displayYears() {
      return Array.from({ length: this.calculationPeriod }, (_, i) => i + 1);
    },
    yearSpanGroups() {
      const groups = [];
      let currentType = null;
      let startIndex = 0;

      for (let i = 0; i < this.displayYears.length; i++) {
        const year = this.displayYears[i];
        const isConstruction = year <= this.constructionPeriod;
        const type = isConstruction ? "construction" : "operation";

        if (currentType === null) {
          currentType = type;
        } else if (type !== currentType) {
          groups.push({
            type: currentType,
            start: startIndex,
            length: i - startIndex,
          });
          currentType = type;
          startIndex = i;
        }
      }

      groups.push({
        type: currentType,
        start: startIndex,
        length: this.displayYears.length - startIndex,
      });

      return groups;
    },
    totalCost() {
      // 从store获取成本费用数据
      const costData = this.projectData["成本费用"] || {};
      console.log("成本费用：", costData);

      return {
        inputData: {
          repairRate: costData.repaircost || 0,
          otherCost: costData.othercost || 0,
        },
        rawmaterial: {
          total: costData["原辅材料"]?.total?.total || 0,
          year: costData["原辅材料"]?.total?.year || [],
        },
        fuelPpower: {
          total: costData["燃料动力"]?.total?.total || 0,
          year: costData["燃料动力"]?.total?.year || [],
        },
        wagesBenefits: {
          total:
            costData["职工薪酬"]?.total?.gzfltotal ||
            costData["职工薪酬"]?.total?.total ||
            0,
          year:
            costData["职工薪酬"]?.total?.gzfl ||
            costData["职工薪酬"]?.total?.year ||
            [],
        },
        repair: {
          total: costData["修理费"]?.total || 0,
          year: costData["修理费"]?.year || [],
        },
        other: {
          total: costData["其他费用"]?.total || 0,
          year: costData["其他费用"]?.year || [],
        },
        depreciation: {
          total: costData["折旧"]?.total?.depreciationTotal || 0,
          year: costData["折旧"]?.total?.depreciationValues || [],
        },
        Amortization: {
          total:
            costData["摊销"]?.total?.depreciationTotal ||
            costData["摊销"]?.total?.amortizationTotal ||
            0,
          year:
            costData["摊销"]?.total?.depreciationValues ||
            costData["摊销"]?.total?.amortizationValues ||
            [],
        },
        interest: {
          total: costData["利息"]?.total || 0,
          year: costData["利息"]?.year || [],
        },
        Operatingcosts: {
          total: costData["经营成本"]?.total || 0,
          year: costData["经营成本"]?.year || [],
        },
        fixedcost: {
          total: costData["固定成本"]?.total || 0,
          year: costData["固定成本"]?.year || [],
        },
        variablecost: {
          total: costData["可变成本"]?.total || 0,
          year: costData["可变成本"]?.year || [],
        },
        Totalcost: {
          total: costData["总成本费用"]?.total || 0,
          year: costData["总成本费用"]?.year || [],
        },
      };
    },
  },
  watch: {
    "basicData.calculationPeriod": {
      handler() {
        this.updateTotalCost();
      },
      deep: false,
    },
    "basicData.constructionPeriod": {
      handler() {
        this.updateTotalCost();
      },
      deep: false,
    },
    "basicData.operationPeriod": {
      handler() {
        this.updateTotalCost();
      },
      deep: false,
    },
  },
  mounted() {
    // 启动时调用comp.js进行初始化
    totalCost();
  },
  methods: {
    updateTotalCost() {
      // 先将参数存入Vuex
      const currentProjectData = this.$store.state.projectData || {};
      currentProjectData["成本费用"] = currentProjectData["成本费用"] || {};
      currentProjectData["成本费用"].repaircost = this.inputData.repairRate;
      currentProjectData["成本费用"].othercost = this.inputData.otherCost;

      // 更新store
      this.$store.commit("SET_PROJECT_DATA", currentProjectData);

      // 然后调用comp.js中的函数进行计算
      this.$nextTick(() => {
        totalCost();
        workingCapital();
      });
    },
    getFormData() {
      return this.inputData;
    },
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "";
      if (num === 0) return "";
      return Number(num)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.total-cost-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.input-area {
  padding: 15px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.input-row {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.input-field {
  width: 120px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  text-align: right;
}

.input-field:focus {
  border-color: #409eff;
}

.input-unit {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.table-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.table-scroll-area {
  flex: 1;
  overflow: auto;
}

.total-cost-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}

.total-cost-table th,
.total-cost-table td {
  text-align: center;
  border: 1px solid #dfe6ec;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.total-cost-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.seq-col {
  width: 50px;
  min-width: 50px;
}

.item-col {
  width: 150px;
  min-width: 150px;
  text-align: left;
}

.total-col {
  width: 100px;
  min-width: 100px;
  font-weight: 600;
}

.year-col {
  padding: 4px 2px;
}

.period-type-col {
  background: #e8f4f8;
}

.summary-row {
  background: #f0f9eb;
  font-weight: 600;
}

.summary-row:hover {
  background: #e1f3d8;
}

.highlight-row {
  background: #fff7e6;
  font-weight: 600;
}

.highlight-row:hover {
  background: #ffe4b3;
}

.bold-row {
  font-weight: 600;
}

.bold-row:hover {
  background: #f5f5f5;
}
</style>
